import React from "react"
import { Auth } from "../../../Components/Views/Auth/Auth"
import { AuthFormView } from "../../../Models/Client/AuthFormView"

export function ResetPasswordRoute() {
    return <Auth type={AuthFormView.reset} squashSuccessMessage={false} />
}
